import { Menu, Moon, Sun, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import BrandLogo from './BrandLogo.jsx';

const links = [
  ['#hazards', 'Опасности'], ['#how-it-works', 'Как работает'], ['#early-access', 'Ранний доступ'], ['#tiers', 'Доступ'],
];

export default function LandingHeader({ betaMode, themeMode, onThemeChange, onOpenAuth }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const nextTheme = themeMode === 'dark' ? 'light' : 'dark';
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="landing-header">
      <div className="landing-wrap landing-nav">
        <Link to="/" className="landing-brand" onClick={closeMenu}><BrandLogo />{betaMode && <span className="beta-badge">Beta</span>}</Link>
        <nav className={`landing-nav-links ${menuOpen ? 'is-open' : ''}`} aria-label="Разделы страницы">
          {links.filter(([href]) => betaMode || href !== '#early-access').map(([href, label]) => (
            <a key={href} href={href} onClick={closeMenu}>{label}</a>
          ))}
        </nav>
        <div className="landing-nav-actions">
          <button className="landing-icon-button" onClick={() => onThemeChange(nextTheme)} aria-label={nextTheme === 'dark' ? 'Включить тёмную тему' : 'Включить светлую тему'} title="Сменить тему">
            {themeMode === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
          </button>
          <button className="landing-button landing-button-ghost landing-login" onClick={() => onOpenAuth('login')}>Войти</button>
          <button className="landing-button landing-button-primary landing-register" onClick={() => onOpenAuth('register')}>{betaMode ? 'Получить ранний доступ' : 'Зарегистрироваться'}</button>
          <button className="landing-menu-button" onClick={() => setMenuOpen((open) => !open)} aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'} aria-expanded={menuOpen}>
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
    </header>
  );
}
